const URL_REGEX = /^(http[s]?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}\.?/;

class UrlUtil {
  public static isUrl(text: unknown): boolean {
    if (typeof text != 'string') return false;
    const value = text.trim();
    if (value.length == 0 || /\s/.test(value)) return false;
    return URL_REGEX.test(value);
  }

  public static toHref(text: string): string {
    const value = text.trim();
    return /^https?:\/\//i.test(value) ? value : `https://${value}`;
  }
}

export default UrlUtil;
